import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { loginRequested, resetPasswordRequested } from "store/auth/authSlice";

export function useLogin() {
  const dispatch = useDispatch();

  const onLogin = useCallback(
    async (values: any, actions: any) => {
      values.userType = 0;
      actions.setSubmitting(true);
      await dispatch(loginRequested(values));

      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );

  return { onLogin };
}

export function useResetPassword() {
  const dispatch = useDispatch();
  const { auth } = useSelector((state: RootState) => state.auth);

  const onResetPassword = useCallback(
    async (values: any) => {
      await dispatch(
        resetPasswordRequested({
          currentPassword: values?.currentPassword,
          newPassword: values?.newPassword,
          userId: auth?.user?.id,
        })
      );
    },
    [dispatch]
  );

  return { onResetPassword };
}
